import { GridCellProps } from '@progress/kendo-react-grid'
import { LuckyDrawRewardDetailsKey } from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'

import { GridColumn } from './CampaignDetailsResultsPage'

const luckyDrawRewardsColumn: GridColumn[] = [
  {
    title: 'Number',
    field: LuckyDrawRewardDetailsKey.Number,
    show: true,
    className: 'table-columns__content',
    width: 90,
  },
  {
    title: 'Type',
    field: LuckyDrawRewardDetailsKey.RewardType,
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Currency',
    field: LuckyDrawRewardDetailsKey.Currency,
    cell: (props: GridCellProps): JSX.Element => {
      const currencyId = props.dataItem?.currency?.id
      return <td>{currencyId ?? 'NA'}</td>
    },
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Reward',
    field: LuckyDrawRewardDetailsKey.Reward,
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Top Prize',
    field: LuckyDrawRewardDetailsKey.TopPrize,
    cell: (props: GridCellProps): JSX.Element => <td>{props.dataItem?.topPrize ? 'Yes' : 'No'}</td>,
    show: true,
    className: 'table-columns__content',
    width: 110,
  },
  {
    title: 'Reward Chance Weight %',
    field: LuckyDrawRewardDetailsKey.RewardChanceWeight,
    show: true,
    className: 'table-columns__content',
    width: 200,
  },
]

export default luckyDrawRewardsColumn
